import { z } from '@customerio/hydra-validation';
import type { TransactionalMessage as ApiTransactionalMessage } from '@customerio/hydra-ui-api';
import { defineEntity, readSchema } from '../shared/define-entity';
import { UserMinimalFromApi } from '../shared/user-minimal-from-api';

/**
 * Transactional message entity — workspace-scoped.
 *
 * `id` is normalized to `string` (the wire ships a number). The created/updated
 * users are `null` on the wire when the audit log has no author, and are
 * normalized to `undefined` so the optional generated type holds.
 */
export type TransactionalMessage = Omit<ApiTransactionalMessage, 'id'> & { id: string };

const TransactionalMessageFromApi = readSchema<TransactionalMessage>(
  z.looseObject({
    id: z.number().transform(String),
    created_by_user: UserMinimalFromApi.nullish().transform((user) => user ?? undefined),
    updated_by_user: UserMinimalFromApi.nullish().transform((user) => user ?? undefined),
  }),
);

/** @public */
export const transactionalMessage = defineEntity<TransactionalMessage>({
  name: 'transactional_message',
  scope: 'workspace',
  pk: (m) => m.id,
  schema: { read: TransactionalMessageFromApi },
});

export const transactionalMessageKeys = transactionalMessage.keys;

export function parseTransactionalMessage(raw: ApiTransactionalMessage): TransactionalMessage {
  return transactionalMessage.parse(raw);
}
